module.exports = __webpack_public_path__ + "pe.svg?7282496650607b18f8e1649b6f4e8025";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pe.svg
// module id = 907
// module chunks = 27